import React, { FC } from 'react';
import { Typography, Unstable_Grid2 as Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { CapabilitySwitch, CustomSVG } from 'components';
import { useFormikContext } from 'formik';

import { AdminUpdateClient } from 'features/admin/types';
import { UseCapabilityToggle } from 'types/app';

interface Props {
  slackToggle: UseCapabilityToggle;
  teamsToggle: UseCapabilityToggle;
}

const Integrations: FC<Props> = ({ slackToggle, teamsToggle }) => {
  const { t } = useTranslation();
  const { setFieldValue } = useFormikContext<AdminUpdateClient>();

  function onChangeSlack(nextValue: boolean) {
    slackToggle.onChange(nextValue);
    setFieldValue('slack_integration', nextValue);
  }

  function onChangeTeams(nextValue: boolean) {
    teamsToggle.onChange(nextValue);
    setFieldValue('ms_teams_integration', nextValue);
  }

  return (
    <Grid container direction="column" wrap="nowrap" spacing={2}>
      <Grid>
        <Grid container alignItems="center">
          <Grid xs>
            <Grid container alignItems="center" spacing={1}>
              <Grid>
                <CustomSVG name="slack" />
              </Grid>
              <Grid>
                <Typography variant="body2" display="inline">
                  {t('admin:workspaceSlackTitle')}
                </Typography>
                <Typography color="textSecondary" display="inline">
                  {` - ${t('admin:workspaceSlackDescription')}`}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid>
            <CapabilitySwitch checked={slackToggle.isActive} onChange={onChangeSlack} />
          </Grid>
        </Grid>
      </Grid>
      <Grid>
        <Grid container alignItems="center">
          <Grid xs>
            <Grid container alignItems="center" spacing={1}>
              <Grid>
                <CustomSVG name="msteams" />
              </Grid>
              <Grid>
                <Typography variant="body2" display="inline">
                  {t('admin:workspaceTeamsTitle')}
                </Typography>
                <Typography color="textSecondary" display="inline">
                  {` - ${t('admin:workspaceTeamsDescription')}`}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid>
            <CapabilitySwitch checked={teamsToggle.isActive} onChange={onChangeTeams} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Integrations;
